import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import { Tooltip } from "antd";
import { ListProps } from "../../../../servers";
import FileIcon from "../../../../../../pages/CourseDetail/Courseware/components/FileIcon";

interface AsideLinkProps {
    item: ListProps;
    desc?: string;
    active?: boolean;
    onClick: () => void;
    finished?: boolean;
}

export default function AsideLink({ item, active, onClick }: AsideLinkProps) {
    return (
        <div
            className={classNames(styles.root, { [styles.active]: active })}
            onClick={onClick}>
            <FileIcon className={styles.icon} ext={item.fileType} />
            <div className={styles.inforow}>
                <h1 className={styles.title}>
                    <Tooltip title={item?.fileName}>{item?.fileName}</Tooltip>
                </h1>
                {item?.fileSize && (
                    <p className={styles.desc}>大小 {item?.fileSize}</p>
                )}
            </div>
        </div>
    );
}
